export const tailleFichiers = (fichiers) => {
    let size = 0;
    for (let i = 0; i < fichiers.length; i += 1) {
        size += fichiers[i].size;
    }
    return size;
};

export const mimeTypesAccepted = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'];

export const formatFichiers = (fichiers, tab) => {
    for (let i = 0; i < fichiers.length; i += 1) {
        if (!tab.includes(fichiers[i].type)) {
            return false;
        }
    }
    return true;
};
